export default {
  'cn': {
    i18n: {
      breadcrumb: '智慧物联数据可视化平台',
      items: [
        {
          icon: "iconfont httpicon-rizhiguanli",
          index: "bluetoothInput",
          title: "蓝牙录入权限",
          key: 'BLUETOOTH_INPUT',
          status: 0,
          show:true,
          id:0,
          pid:0,
          ChildrenStatus: false
        },
        {
          icon: "iconfont httpicon-rizhiguanli",
          index: "DeviceManagementPermissions",
          title: "设备重置初始化权限",
          key: 'DEVICE_MANAGEMENT_PERMISSIONS',
          status: 0,
          id:130,
          show:true,
          pid:0,
          ChildrenStatus: false
        },
        {
          icon: "iconfont httpicon-rizhiguanli",
          index: "NormallyOpenPermission",
          title: "常开权限",
          key: 'NORMALLY_OPEN_PERMISSION',
          status: 0,
          show:true,
          ChildrenStatus: false,
          pid:74,
          id:74,
        },
        {
          icon: "iconfont httpicon-rizhiguanli",
          index: "PropertyOperationPermissions",
          title: "房源操作权限",
          key: 'PROPERTY_OPERATION_PERMISSIONS',
          status: 0,
          show:true,
          ChildrenStatus: false,
          pid:120,
          id:120,
        },
        {
          icon: "iconfont httpicon-rizhiguanli",
          index: "FreezePermission",
          title: "冻结权限",
          key: 'FREEZE_PERMISSION',
          status: 0,
          show:true,
          ChildrenStatus: false,
          pid:75,
          id:75,
        },
        {
          icon: "iconfont httpicon-rizhiguanli",
          index: "RemoteControlPermission",
          title: "遥控器权限",
          key: 'REMOTE_CONTROL_PERMISSION',
          status: 0,
          show:true,
          ChildrenStatus: false,
          pid:76,
          id:76
        },
        {
          icon: "iconfont httpicon-shebei",
          index: "RepairManagementAuthority",
          title: "报修管理权限",
          pid: 77,
          id: 77,
          show:true,
          key: 'Repair_management_authority',
          status: 0,
          sort:8,
          ChildrenStatus: false
        },
        {
          icon: "iconfont httpicon-tongjifenxi",
          index: "homepage",
          key: 'STATISTICAL_ANALYSIS',
          status: 0,
          title: "数据汇总",
          id:1,
          pid:1,
          sort:0,
          ChildrenStatus: true,
          subs: [
            // {
            //   icon: "iconfont httpicon-shouye",
            //   index: "home",
            //   title: "首页",
            //   key: 'ALLHOME',
            //   status: 0,
            //   id:2,
            //   pid:1,
            //   ChildrenStatus: false,
            // },
            // {
            //   icon: "iconfont httpicon-shouye",
            //   index: "visualization",
            //   title: "大屏展示",
            //   key: 'visualization',
            //   status: 0,
            //   id:3,
            //   pid:1,
            //   ChildrenStatus: false,
            // },
            // {
            //   icon: "iconfont httpicon-shouye",
            //   index: "flatsIndex",
            //   title: "首页",
            //   key: 'flatsIndex',
            //   status: 0,
            //   id:2,
            //   pid:1,
            //   ChildrenStatus: false,
            // },
            {
              icon: "iconfont httpicon-shouye",
              index: "visualization",
              title: "大屏展示",
              key: 'visualization',
              status: 0,
              id:3,
              pid:1,
              ChildrenStatus: false,
            },

            {
              icon: "iconfont httpicon-shouye",
              index: "homepage",
              title: "门锁首页",
              key: 'HOME_PAGE',
              status: 0,
              id:4,
              pid:1,
              ChildrenStatus: false,
            },
            {
              icon: "iconfont httpicon-shouye",
              index: "watermeterhomepage",
              title: "水表首页",
              key: 'WATER_METER',
              status: 0,
              id:5,
              pid:1,
              ChildrenStatus: false,
            },
            {
              icon: "iconfont httpicon-shouye",
              index: "electricitymeterhomepage",
              title: "电表首页",
              key: 'ELECTRIC_METER',
              status: 0,
              id:6,
              pid:1,
              ChildrenStatus: false,
            },
            {
              icon: "iconfont httpicon-shouye",
              index: "index",
              title: "门磁首页",
              key: 'INDEX',
              status: 0,
              id:7,
              pid:1,
              ChildrenStatus: false,
            },
            // {
            //   icon: "iconfont httpicon-shouye",
            //   index: "trashMonitorHomePage",
            //   title: "垃圾桶检测器",
            //   key: 'TRASHMONITORHOMEPAGE',
            //   status: 0,
            //   id:8,
            //   pid:1,
            //   ChildrenStatus: false,
            // },{
            //   icon: "iconfont httpicon-shouye",
            //   index: "airQualityMonitorHomePage",
            //   title: "空气传感器",
            //   key: 'AIRQUALITYMONITORHOMEPAGE',
            //   status: 0,
            //   id:9,
            //   pid:1,
            //   ChildrenStatus: false,
            // },
            // {
            //   icon: "iconfont httpicon-shouye",
            //   index: "smokeSensationDeviceHomePage",
            //   title: "烟感首页",
            //   key: 'SMOKESENSATIONDEVICEHOMEPAGE',
            //   status: 0,
            //   id:10,
            //   pid:1,
            //   ChildrenStatus: false,
            // },
            // {
            //   icon: "iconfont httpicon-shouye",
            //   index: "homePageEnvironmentalQualityMonitor",
            //   title: "环境质量监测器首页",
            //   key: 'HOMEPAGEENVIRONMENTALQUALITYMONITOR',
            //   status: 0,
            //   ChildrenStatus: false,
            // },
            // {
            //   icon: "iconfont httpicon-shouye",
            //   index: "manholeCoverMonitorHomePage",
            //   title: "井盖监测器",
            //   key: 'MANHOLECOVERMONITORHOMEPAGE',
            //   status: 0,
            //   id:11,
            //   pid:1,
            //   ChildrenStatus: false,
            // },{
            //   icon: "iconfont httpicon-shouye",
            //   index: "smartButtonHomePage",
            //   title: "智能按钮",
            //   key: 'SMARTBUTTONHOMEPAGE',
            //   status: 0,
            //   id:12,
            //   pid:1,
            //   ChildrenStatus: false,
            // },{
            //   icon: "iconfont httpicon-shouye",
            //   index: "acoustoopticAlarmHomePage",
            //   title: "声光报警器",
            //   key: 'ACOUSTOOPTICALARMHOMEPAGE',
            //   status: 0,
            //   id:13,
            //   pid:1,
            //   ChildrenStatus: false,
            // },
            // {
            //   icon: "iconfont httpicon-shouye",
            //   index: "homePageDistributionCabinetIsEmpty",
            //   title: "配电柜空开",
            //   key: 'HOME_PAGE_DISTRIBUTION_CABINET_IS_EMPTY',
            //   status: 0,
            //   id:14,
            //   pid:1,
            //   ChildrenStatus: false,
            // },
            // {
            //   icon: "iconfont httpicon-shouye",
            //   index: "infraredAlarmHomePage",
            //   title: "红外报警",
            //   key: 'INFRAREDALARMHOMEPAGE',
            //   status: 0,
            //   id:15,
            //   pid:1,
            //   ChildrenStatus: false,
            // },
            // {
            //   icon: "iconfont httpicon-shouye",
            //   index: "homePageWaterAndElectricityMeter",
            //   title: "水电表",
            //   key: 'HOME_PAGE_WATER_AND_ELECTRICITY_METER',
            //   status: 0,
            //   id:14,
            //   pid:1,
            //   ChildrenStatus: false,
            // },
            // {
            //   icon: "iconfont httpicon-shouye",
            //   index: "sharedHotWaterHomePage",
            //   title: "共享热水",
            //   key: 'SHARED_HOT_WATER_HOME_PAGE',
            //   status: 0,
            //   id:161,
            //   pid:1,
            //   ChildrenStatus: false,
            // },
          ],
        },
        {
          icon: "iconfont httpicon-loufang01",
          index: "room",
          title: "房源管理",
          key: 'AREA_MANAGEMENT',
          status: 0,
          id:16,
          pid:16,
          sort:1,
          ChildrenStatus: true,
          subs: [{
            index: "room",
            title: "门锁房源列表",
            key: 'STUDENT_DORMITORY',
            status: 0,
            id:17,
            pid:16,
            ChildrenStatus: false,
          },
            {
              index: "Architecture",
              title: "门磁房源列表",
              key: 'ARCCHITECTURE',
              status: 0,
              id:18,
              pid:16,
              ChildrenStatus: false,
            },
            // {
            //   index: "offInHouse",
            //   title: "离线房源",
            //   key: 'OFF_IN_HOUSE',
            //   status: 0,
            //   ChildrenStatus: false,
            // },
          ],
        },
        {
          icon: "iconfont httpicon-yewuguanli",
          index: "Lease",
          title: "租约管理",
          key: 'LEASE MANAGEMENT',
          status: 0,
          ChildrenStatus: true,
          pid: 106,
          id: 106,
          sort:3,
          subs: [{
            icon: "iconfont httpicon-rizhiguanli",
            index: "agreement",
            title: "合同管理",
            key: 'AGREEMENT',
            status: 0,
            pid: 106,
            id: 108,
            ChildrenStatus: false
          },
            {
              icon: "iconfont httpicon-rizhiguanli",
              index: "contractExportTemplate",
              title: "合同导出模板",
              key: 'CONTRACT_EXPORT_TEMPLATE',
              status: 0,
              pid: 106,
              id: 109,
              ChildrenStatus: false,
            }]
        },
        {
          icon: "iconfont httpicon-yewuguanli",
          index: "CheckIn",
          title: "业务管理",
          key: 'OPERATIONS_MANAGEMENT',
          status: 0,
          id:19,
          pid:19,
          sort:2,
          ChildrenStatus: true,
          subs: [{
            icon: "el-icon-lx-copy",
            index: "RoomInquiry",
            title: "门锁业务",
            key: 'ACCOMMODATION_OPERATION',
            status: 0,
            id:20,
            pid:19,
            ChildrenStatus: true,
            subs: [{
              index: "CheckIn",
              title: "入住办理",
              key: 'ACCOMMODATION_REGISTER',
              status: 0,
              id:21,
              pid:20,
              ChildrenStatus: false,
            },
              {
                index: "Refund",
                title: "退住管理",
                key: 'CHECK_OUT_MANAGEMENT',
                status: 0,
                id:22,
                pid:20,
                ChildrenStatus: false,
              },
              {
                index: "renewalHandling",
                title: "续住管理",
                key: 'RENEWAL_HANDLING',
                status: 0,
                id:23,
                pid:20,
                ChildrenStatus: false,
              },
              {
                index: "Freeze",
                title: "冻结管理",
                key: 'FREEZE_MANAGEMENT',
                status: 0,
                id:24,
                pid:20,
                ChildrenStatus: false,
              },
              {
                index: "linkperson",
                title: "接警联系人",
                key: 'LINKPERSON',
                status: 0,
                id:25,
                pid:20,
                ChildrenStatus: false,
              },
            ],
          },
            {
              icon: "el-icon-lx-copy",
              index: "Linkman",
              title: "门磁业务",
              key: 'DOORMAGNETICSERVICE',
              status: 0,
              id:26,
              pid:19,
              ChildrenStatus: true,
              subs: [{
                index: "Linkman",
                title: "接警联系人",
                key: 'LINKMAN',
                status: 0,
                id:27,
                pid:26,
                ChildrenStatus: false,
              }, ],
            },{
              index: "offInCardManage",
              title: "离线卡管理",
              key: 'OFF_IN_CARD_MANAGE',
              status: 0,
              id:28,
              pid:19,
              ChildrenStatus: true,
              subs:[
                {
                  index: "offInCardOver",
                  title: "离线卡操作",
                  key: 'OFF_IN_CARD_OVER',
                  status: 0,
                  id:29,
                  pid:28,
                  ChildrenStatus: false
                },
                {
                  index: "offInCardList",
                  title: "离线卡列表",
                  key: 'OFF_IN_CARD_LIST',
                  status: 0,
                  id:30,
                  pid:28,
                  ChildrenStatus: false
                }
              ]
            },
          ],
        },
        {
          icon: "iconfont httpicon-yiqiatong",
          index: "userManagement",
          title: "人员管理",
          key: 'PERSONNEL_MANAGEMENT',
          status: 0,
          id:31,
          pid:31,
          sort:2,
          ChildrenStatus: true,
          subs: [{
            index: "userManagement",
            title: "人员列表",
            key: 'STUDENT_INFORMATION',
            status: 0,
            id:32,
            pid:31,
            ChildrenStatus: false,
          },
            {
              index: "VoucherList",
              title: "凭证管理",
              key: 'RENT_SURRENDER_MANAGEMENT',
              status: 0,
              id:33,
              pid:31,
              ChildrenStatus: false,
            },
            // {
            //   index: "bluetoothButtonManage",
            //   title: "蓝牙扣管理",
            //   key: 'BLUETOOTH_BUTTON_MANAGE',
            //   status: 0,
            //   id:34,
            //   pid:31,
            //   ChildrenStatus: false,
            // },
            // {
            //   index: "InformationBase",
            //   title: "信息库",
            //   key: 'INFORMATIONBASE',
            //   status: 0,
            //   id:35,
            //   pid:31,
            //   ChildrenStatus: false,
            // },
          ],
        },
        {
          icon: "iconfont httpicon-shebei",
          index: "doorLock",
          title: "设备管理",
          key: 'DEVICE_MANAGEMENT',
          status: 0,
          id:36,
          pid:36,
          sort:4,
          ChildrenStatus: true,
          subs: [{
            icon: "el-icon-lx-copy",
            index: "doorLock",
            title: "门锁设备",
            key: 'DOOR_LOCK_DEVICE',
            status: 0,
            id:37,
            pid:36,
            ChildrenStatus: false,
          },{
            icon: "el-icon-lx-copy",
            index: "waterMeterDevice",
            title: "水表设备",
            key: 'WATER_METER_DEVICE',
            status: 0,
            id:370,
            pid:36,
            ChildrenStatus: false,
          },{
            icon: "el-icon-lx-copy",
            index: "electricMeterDevice",
            title: "电表设备",
            key: 'ELECTRIC_METER_DEVICE',
            status: 0,
            id:371,
            pid:36,
            ChildrenStatus: false,
          },
            {
              icon: "el-icon-lx-copy",
              index: "EquipmentList",
              title: "门磁设备",
              key: 'EQUIPMENTLIST',
              status: 0,
              id:38,
              pid:36,
              ChildrenStatus: false,
            },
            //   {
            //   icon: "el-icon-lx-copy",
            //   index: "airSwitchDevice",
            //   title: "空开设备",
            //   key: 'AIRSWITCH',
            //   status: 0,
            //   id:39,
            //   pid:36,
            //   ChildrenStatus: false,
            // },
            // {
            //   icon: "el-icon-lx-copy",
            //   index: "smokeSensationDevice",
            //   title: "烟感设备",
            //   key: 'SMOGDETECTOR',
            //   status: 0,
            //   id:40,
            //   pid:36,
            //   ChildrenStatus: false,
            // },
            // {
            //   icon: "el-icon-lx-copy",
            //   index: "AirCleaningDevice",
            //   title: "空气净化",
            //   key: 'AIRCLEANER',
            //   status: 0,
            //   ChildrenStatus: false,
            // },
            // {
            //   icon: "el-icon-lx-copy",
            //   index: "smartButtonDevice",
            //   title: "智能按钮",
            //   key: 'ACTIVEBUTTON',
            //   status: 0,
            //   id:41,
            //   pid:36,
            //   ChildrenStatus: false,
            // },
            //   {
            //   icon: "el-icon-lx-copy",
            //   index: "manholeCoverDevice",
            //   title: "井盖",
            //   key: 'MANHOLECOVER',
            //   status: 0,
            //     id:42,
            //     pid:36,
            //   ChildrenStatus: false,
            // },
            //   {
            //   icon: "el-icon-lx-copy",
            //   index: "trashCanDevice",
            //   title: "垃圾桶",
            //   key: 'GARBAGE',
            //   status: 0,
            //     id:43,
            //     pid:36,
            //   ChildrenStatus: false,
            // },
            {
              icon: "el-icon-lx-copy",
              index: "gatewayDevice",
              title: "网关",
              key: 'GATEWAY',
              status: 0,
              id:44,
              pid:36,
              ChildrenStatus: false,
            },
            //   {
            //   icon: "el-icon-lx-copy",
            //   index: "airDetectionDevice",
            //   title: "空气检测传感器",
            //   key: 'AIRDETECTION',
            //   status: 0,
            //     id:45,
            //     pid:36,
            //   ChildrenStatus: false,
            // }, {
            //   icon: "el-icon-lx-copy",
            //   index: "humanMotionSensorDevice",
            //   title: "红外传感器",
            //   key: 'HUMANMOVING',
            //   status: 0,
            //     id:46,
            //     pid:36,
            //   ChildrenStatus: false,
            // },{
            //   icon: "el-icon-lx-copy",
            //   index: "acoustoopticAlarm",
            //   title: "声光报警",
            //   key: 'ACOUSTOOPTIC_ALARM',
            //   status: 0,
            //     id:47,
            //     pid:36,
            //   ChildrenStatus: false,
            // },{
            //   icon: "el-icon-lx-copy",
            //   index: "quantityConfiguration",
            //   title: "设备数量",
            //   key: 'quantityConfiguration',
            //   status: 0,
            //     id:48,
            //     pid:36,
            //   ChildrenStatus: false,
            // },
          ],
        },
        {
          icon: "iconfont httpicon-yiqiatong",
          index: "accessControl",
          title: "门禁管理",
          key: 'ACCESS_CONTROL',
          status: 0,
          id: 77,
          pid: 77,
          sort:5,
          ChildrenStatus: false,
        },
        {
          icon: 'iconfont httpicon-shebei',
          index: "garageGate",
          title: "车库道闸",
          key: 'GARAGE_GATE',
          status: 0,
          id: 78,
          pid: 78,
          ChildrenStatus: false
        },
        {
          icon: "iconfont httpicon-yonghuguanli",
          index: "loginAccount",
          title: "用户管理",
          key: 'USER_MANAGEMENT',
          status: 0,
          id:49,
          pid:49,
          sort:5,
          ChildrenStatus: true,
          subs: [{
            index: "loginAccount",
            title: "登录账号",
            key: 'ACCOUNT_MANAGEMENT',
            status: 0,
            id:50,
            pid:49,
            ChildrenStatus: false,
          },
            // {
            //   index: "userManagementHouse",
            //   title: "门磁登录账号",
            //   key: 'DOORMAGENTLOGINACCOUNT',
            //   status: 0,
            // },
            {
              index: "rolePermissions",
              title: "角色权限",
              key: 'ROLE_PERMISSIONS',
              status: 0,
              id:51,
              pid:49,
              ChildrenStatus: false,
            },
            {
              index: "bindingRoles",
              title: "绑定角色",
              key: 'BOUND_ROLE',
              status: 0,
              id:52,
              pid:49,
              ChildrenStatus: false,
            },
            // {
            //   index: "configPage",
            //   title: "配置",
            //   key: 'CONFIGPAGE',
            //   status: 0,
            //   id:53,
            //   pid:49,
            //   ChildrenStatus: false,
            // },
          ],
        },
        {
          icon: "iconfont httpicon-pingzhengguanli",
          index: "rechargeManagement",
          title: "财务管理",
          key: 'RECHARGE_MANAGEMENT',
          status: 0,
          pid:90,
          id:90,
          sort:4,
          ChildrenStatus: true,
          subs: [
            {
              icon: "iconfont httpicon-pingzhengguanli",
              index: "bill",
              title: "账单",
              key: 'BILL',
              status: 0,
              pid:90,
              id:91,
              ChildrenStatus: false
            },
            {
              icon: "iconfont httpicon-pingzhengguanli",
              index: "rechargeManagement",
              title: "充值",
              key: 'RECHARGE_MANAGEMENT',
              status: 0,
              pid:90,
              id:92,
              ChildrenStatus: false
            }
          ]
        },
        // {
        //   icon: "iconfont httpicon-pingzhengguanli",
        //   index: "rechargeManagement",
        //   title: "充值管理",
        //   key: 'RECHARGE_MANAGEMENT',
        //   status: 0,
        //   id:54,
        //   pid:54,
        //   ChildrenStatus: false,
        // },
        {
          icon: "iconfont httpicon-liebiao1",
          index: "priceManagement",
          title: "价格管理",
          pid: 605,
          id: 656,
          key: 'PRICE_MANAGEMENT',
          status: 0,
          sort:4,
          ChildrenStatus: true,
          subs: [
            {
              index: "singlePrice",
              title: "价格管理",
              key: 'SINGLE_PRICE',
              status: 0,
              id:657,
              pid:656,
              ChildrenStatus: false,
            },
            //   {
            //   index: "tieredPricing",
            //   title: "阶梯价格",
            //   key: 'TIERED_PRICING',
            //   status: 0,
            //   id:658,
            //   pid:656,
            //   ChildrenStatus: false,
            // },{
            //   index: "compoundRatePrice",
            //   title: "复费率价格",
            //   key: 'COMPOUND_RATE_PRICE',
            //   status: 0,
            //   id:659,
            //   pid:656,
            //   ChildrenStatus: false,
            // },{
            //   index: "doubleMeteringPrice",
            //   title: "双计量价格",
            //   key: 'DOUBLE_METERING_PRICE',
            //   status: 0,
            //   id:660,
            //   pid:656,
            //   ChildrenStatus: false,
            // },
          ]
        },
        {
          icon: "iconfont httpicon-rizhiguanli",
          index: "journal",
          title: "日志管理",
          key: 'LOG_MANAGEMENT',
          status: 0,
          id:55,
          pid:55,
          sort:6,
          ChildrenStatus: true,
          subs: [{
            index: "journal",
            title: "系统日志",
            key: 'journal',
            status: 0,
            id:56,
            pid:55,
            ChildrenStatus: false,
          },
            {
              index: "doorLockLlog",
              title: "门锁日志",
              key: 'DOORLOCKLOG',
              status: 0,
              id:57,
              pid:55,
              ChildrenStatus: true,
              subs: [{
                index: "warningLog",
                title: "告警日志",
                key: 'warningLog',
                status: 0,
                id:58,
                pid:57,
                ChildrenStatus: false,
              },
                {
                  index: "UnlockRecord",
                  title: "开锁记录",
                  key: 'UnlockRecord',
                  status: 0,
                  id:59,
                  pid:57,
                  ChildrenStatus: false,
                },
                {
                  index: "bluetoothUnlockRecord",
                  title: "蓝牙开锁",
                  key: 'bluetoothUnlockRecord',
                  status: 0,
                  id:60,
                  pid:57,
                  ChildrenStatus: false,
                },
                {
                  index: "NoNc",
                  title: "常开常闭",
                  key: 'NONC',
                  status: 0,
                  id:61,
                  pid:57,
                  ChildrenStatus: false,
                },
                {
                  index: "DeviceFeedbackLog",
                  title: "操作记录",
                  key: 'DeviceFeedbackLog',
                  status: 0,
                  id:62,
                  pid:57,
                  ChildrenStatus: false,
                },
              ]
            },
            {
              index: "alarmRecord",
              title: "门磁日志",
              key: 'DOORMAGNETICLOG',
              status: 0,
              id:63,
              pid:55,
              ChildrenStatus: true,
              subs: [{
                index: "alarmRecord",
                title: "报警日志",
                key: 'ALARMRECORD',
                status: 0,
                id:64,
                pid:63,
                ChildrenStatus: false,
              }]
            },
            // {
            //   index: "emptyLog",
            //   title: "空开日志",
            //   key: 'EMPTYLOG',
            //   status: 0,
            //   id:65,
            //   pid:55,
            //   ChildrenStatus: false
            // },
            // {
            //   index: "smokeLog",
            //   title: "烟感日志",
            //   key: 'SMOKELOG',
            //   status: 0,
            //   id:66,
            //   pid:55,
            //   ChildrenStatus: false
            // },
            // {
            //   index: "airCleaningLog",
            //   title: "空气清洁日志",
            //   key: 'AIRCLEANINGLOG',
            //   status: 0,
            //   ChildrenStatus: false
            // },
            // {
            //   index: "smartButtonLog",
            //   title: "智能按钮日志",
            //   key: 'SMART_BUTTON_LOG',
            //   status: 0,
            //   id:67,
            //   pid:55,
            //   ChildrenStatus: false
            // },
            // {
            //   index: "manholeCoverLog",
            //   title: "井盖日志",
            //   key: 'MANHOLE_COVER_LOG',
            //   status: 0,
            //   id:68,
            //   pid:55,
            //   ChildrenStatus: false
            // },
            // {
            //   index: "trashLog",
            //   title: "垃圾桶日志",
            //   key: 'TRASH_LOG',
            //   status: 0,
            //   id:69,
            //   pid:55,
            //   ChildrenStatus: false
            // },
            // {
            //   index: "gatewayLog",
            //   title: "网关日志",
            //   key: 'GATEWAY_LOG',
            //   status: 0,
            //   id:70,
            //   pid:55,
            //   ChildrenStatus: false
            // },
            // {
            //   index: "airDetectionSensorLog",
            //   title: "空气传感器日志",
            //   key: 'AIR_DETECTION_SENSOR_LOG',
            //   status: 0,
            //   id:71,
            //   pid:55,
            //   ChildrenStatus: false
            // },
            // {
            //   index: "humanMotionSensorLog",
            //   title: "红外传感器日志",
            //   key: 'HUMAN_MOTION_SENSOR_LOG',
            //   status: 0,
            //   id:72,
            //   pid:55,
            //   ChildrenStatus: false
            // },
            // {
            //   index: "acoustoopticAlarmLog",
            //   title: "声光报警日志",
            //   key: 'ACOUSTOOPTIC_ALARM_LOG',
            //   status: 0,
            //   id:73,
            //   pid:55,
            //   ChildrenStatus: false
            // },
          ],
        },
        {
          icon: "iconfont httpicon-xitongguanli",
          index: "systemConfiguration",
          title: "系统配置",
          pid:101,
          id:110,
          key: 'SYSTEM_CONFIGURATION',
          status: 0,
          sort:7,
          ChildrenStatus: false
        },
        {
          icon: "iconfont httpicon-xitongguanli",
          index: "byRoom",
          title: "泊寓对接",
          pid:606,
          id:607,
          sort:9,
          key: 'BOYU_Room',
          status: 0,
          ChildrenStatus: false
        },
        {
          icon: "iconfont httpicon-xitongguanli",
          index: "thirdPartyDocking",
          title: "第三方对接",
          pid: 605,
          id: 655,
          key: 'thirdPartyDocking',
          status: 0,
          sort:8,
          ChildrenStatus: false
        },
        {
          icon: "iconfont httpicon-shebei",
          index: "RepairManagement",
          title: "报修管理",
          pid: 605,
          id: 658,
          key: 'Repair_management',
          status: 0,
          sort:8,
          ChildrenStatus: false
        },

      ],
      // items: [
      //   {
      //     icon: "iconfont httpicon-rizhiguanli",
      //     index: "bluetoothInput",
      //     title: "蓝牙录入权限",
      //     key: 'BLUETOOTH_INPUT',
      //     status: 0,
      //     id:0,
      //     pid:0,
      //     ChildrenStatus: false
      //   },
      //   {
      //     icon: "iconfont httpicon-rizhiguanli",
      //     index: "DeviceManagementPermissions",
      //     title: "设备重置初始化权限",
      //     key: 'DEVICE_MANAGEMENT_PERMISSIONS',
      //     status: 0,
      //     id:130,
      //     pid:0,
      //     ChildrenStatus: false
      //   },
      //   {
      //     icon: "iconfont httpicon-rizhiguanli",
      //     index: "PropertyOperationPermissions",
      //     title: "房源操作权限",
      //     key: 'PROPERTY_OPERATION_PERMISSIONS',
      //     status: 0,
      //     ChildrenStatus: false,
      //     pid:120,
      //     id:120,
      //   },
      //   {
      //     icon: "iconfont httpicon-tongjifenxi",
      //     index: "homepage",
      //     key: 'STATISTICAL_ANALYSIS',
      //     status: 0,
      //     title: "数据汇总",
      //     id:1,
      //     pid:1,
      //     ChildrenStatus: true,
      //     subs: [
      //       {
      //         icon: "iconfont httpicon-shouye",
      //         index: "homepage",
      //         title: "门锁首页",
      //         key: 'HOME_PAGE',
      //         status: 0,
      //         id:4,
      //         pid:1,
      //         ChildrenStatus: false,
      //       },
      //     ],
      //   },
      //   {
      //     icon: "iconfont httpicon-loufang01",
      //     index: "room",
      //     title: "房源管理",
      //     key: 'AREA_MANAGEMENT',
      //     status: 0,
      //     id:16,
      //     pid:16,
      //     ChildrenStatus: true,
      //     subs: [{
      //       index: "room",
      //       title: "门锁房源列表",
      //       key: 'STUDENT_DORMITORY',
      //       status: 0,
      //       id:17,
      //       pid:16,
      //       ChildrenStatus: false,
      //     },
      //     ],
      //   },
      //   {
      //     icon: "iconfont httpicon-yewuguanli",
      //     index: "CheckIn",
      //     title: "业务管理",
      //     key: 'OPERATIONS_MANAGEMENT',
      //     status: 0,
      //     id:19,
      //     pid:19,
      //     ChildrenStatus: true,
      //     subs: [{
      //       icon: "el-icon-lx-copy",
      //       index: "RoomInquiry",
      //       title: "门锁业务",
      //       key: 'ACCOMMODATION_OPERATION',
      //       status: 0,
      //       id:20,
      //       pid:19,
      //       ChildrenStatus: true,
      //       subs: [{
      //         index: "CheckIn",
      //         title: "入住办理",
      //         key: 'ACCOMMODATION_REGISTER',
      //         status: 0,
      //         id:21,
      //         pid:20,
      //         ChildrenStatus: false,
      //       },
      //         {
      //           index: "Refund",
      //           title: "退住管理",
      //           key: 'CHECK_OUT_MANAGEMENT',
      //           status: 0,
      //           id:22,
      //           pid:20,
      //           ChildrenStatus: false,
      //         },
      //         {
      //           index: "renewalHandling",
      //           title: "续住管理",
      //           key: 'RENEWAL_HANDLING',
      //           status: 0,
      //           id:23,
      //           pid:20,
      //           ChildrenStatus: false,
      //         },
      //       ],
      //     },
      //     ],
      //   },
      //   {
      //     icon: "iconfont httpicon-yiqiatong",
      //     index: "userManagement",
      //     title: "人员管理",
      //     key: 'PERSONNEL_MANAGEMENT',
      //     status: 0,
      //     id:31,
      //     pid:31,
      //     ChildrenStatus: true,
      //     subs: [{
      //       index: "userManagement",
      //       title: "人员列表",
      //       key: 'STUDENT_INFORMATION',
      //       status: 0,
      //       id:32,
      //       pid:31,
      //       ChildrenStatus: false,
      //     },
      //     ],
      //   },
      //   {
      //     icon: "iconfont httpicon-shebei",
      //     index: "doorLock",
      //     title: "门锁管理",
      //     key: 'DEVICE_MANAGEMENT',
      //     status: 0,
      //     id:36,
      //     pid:36,
      //     ChildrenStatus: true,
      //     subs: [{
      //       icon: "el-icon-lx-copy",
      //       index: "doorLock",
      //       title: "门锁设备",
      //       key: 'DOOR_LOCK_DEVICE',
      //       status: 0,
      //       id:37,
      //       pid:36,
      //       ChildrenStatus: false,
      //     },
      //     ],
      //   },
      //   {
      //     icon: "iconfont httpicon-yonghuguanli",
      //     index: "loginAccount",
      //     title: "用户管理",
      //     key: 'USER_MANAGEMENT',
      //     status: 0,
      //     id:49,
      //     pid:49,
      //     ChildrenStatus: true,
      //     subs: [{
      //       index: "loginAccount",
      //       title: "登录账号",
      //       key: 'ACCOUNT_MANAGEMENT',
      //       status: 0,
      //       id:50,
      //       pid:49,
      //       ChildrenStatus: false,
      //     },
      //       {
      //         index: "rolePermissions",
      //         title: "角色权限",
      //         key: 'ROLE_PERMISSIONS',
      //         status: 0,
      //         id:51,
      //         pid:49,
      //         ChildrenStatus: false,
      //       },
      //       {
      //         index: "bindingRoles",
      //         title: "绑定角色",
      //         key: 'BOUND_ROLE',
      //         status: 0,
      //         id:52,
      //         pid:49,
      //         ChildrenStatus: false,
      //       },
      //     ],
      //   },
      //   {
      //     icon: "iconfont httpicon-rizhiguanli",
      //     index: "journal",
      //     title: "日志管理",
      //     key: 'LOG_MANAGEMENT',
      //     status: 0,
      //     id:55,
      //     pid:55,
      //     ChildrenStatus: true,
      //     subs: [{
      //       index: "journal",
      //       title: "系统日志",
      //       key: 'journal',
      //       status: 0,
      //       id:56,
      //       pid:55,
      //       ChildrenStatus: false,
      //     },
      //       {
      //         index: "doorLockLlog",
      //         title: "门锁日志",
      //         key: 'DOORLOCKLOG',
      //         status: 0,
      //         id:57,
      //         pid:55,
      //         ChildrenStatus: true,
      //         subs: [{
      //           index: "warningLog",
      //           title: "告警日志",
      //           key: 'warningLog',
      //           status: 0,
      //           id:58,
      //           pid:57,
      //           ChildrenStatus: false,
      //         },
      //           {
      //             index: "UnlockRecord",
      //             title: "开锁记录",
      //             key: 'UnlockRecord',
      //             status: 0,
      //             id:59,
      //             pid:57,
      //             ChildrenStatus: false,
      //           },
      //           {
      //             index: "DeviceFeedbackLog",
      //             title: "操作记录",
      //             key: 'DeviceFeedbackLog',
      //             status: 0,
      //             id:62,
      //             pid:57,
      //             ChildrenStatus: false,
      //           },
      //         ]
      //       },
      //     ],
      //   },
      //   {
      //     icon: "iconfont httpicon-xitongguanli",
      //     index: "systemConfiguration",
      //     title: "系统配置",
      //     pid:101,
      //     id:101,
      //     key: 'SYSTEM_CONFIGURATION',
      //     status: 0,
      //     ChildrenStatus: false
      //   },
      // ],

    },
  },
  'en': {
    i18n: {
      breadcrumb: 'Smart IoT Data Visualization Platform',
      items: [
        {
          icon: "iconfont httpicon-rizhiguanli",
          index: "bluetoothInput",
          title: "Bluetooth input permission",
          key: 'BLUETOOTH_INPUT',
          status: 0,
          id:0,
          pid:0,
          ChildrenStatus: false
        },
        {
          icon: "iconfont httpicon-rizhiguanli",
          index: "DeviceManagementPermissions",
          title: "Device reset initialization permission",
          key: 'DEVICE_MANAGEMENT_PERMISSIONS',
          status: 0,
          id:130,
          pid:0,
          ChildrenStatus: false
        },
        {
          icon: "iconfont httpicon-rizhiguanli",
          index: "NormallyOpenPermission",
          title: "Normally open permission",
          key: 'NORMALLY_OPEN_PERMISSION',
          status: 0,
          ChildrenStatus: false,
          pid:74,
          id:74,
        },
        {
          icon: "iconfont httpicon-rizhiguanli",
          index: "PropertyOperationPermissions",
          title: "Property operation permission",
          key: 'PROPERTY_OPERATION_PERMISSIONS',
          status: 0,
          ChildrenStatus: false,
          pid:120,
          id:120,
        },
        {
          icon: "iconfont httpicon-rizhiguanli",
          index: "FreezePermission",
          title: "Freeze permission",
          key: 'FREEZE_PERMISSION',
          status: 0,
          ChildrenStatus: false,
          pid:75,
          id:75,
        },
        {
          icon: "iconfont httpicon-rizhiguanli",
          index: "RemoteControlPermission",
          title: "Remote control permission",
          key: 'REMOTE_CONTROL_PERMISSION',
          status: 0,
          ChildrenStatus: false,
          pid:76,
          id:76
        },
        {
          icon: "iconfont httpicon-tongjifenxi",
          index: "homepage",
          key: 'STATISTICAL_ANALYSIS',
          status: 0,
          title: "Data Summary",
          id:1,
          pid:1,
          ChildrenStatus: true,
          subs: [
            // {
            //   icon: "iconfont httpicon-shouye",
            //   index: "home",
            //   title: "Home",
            //   key: 'ALLHOME',
            //   status: 0,
            //   id:2,
            //   pid:1,
            //   ChildrenStatus: false,
            // },
            // {
            //   icon: "iconfont httpicon-shouye",
            //   index: "flatsIndex",
            //   title: "Home",
            //   key: 'flatsIndex',
            //   status: 0,
            //   id:2,
            //   pid:1,
            //   ChildrenStatus: false,
            // },
            // {
            //   icon: "iconfont httpicon-shouye",
            //   index: "visualization",
            //   title: "大屏展示",
            //   key: 'visualization',
            //   status: 0,
            //   id:3,
            //   pid:1,
            //   ChildrenStatus: false,
            // },
            {
              icon: "iconfont httpicon-shouye",
              index: "visualization",
              title: "Large Screen Display",
              key: 'visualization',
              status: 0,
              id:3,
              pid:1,
              ChildrenStatus: false,
            },

            {
              icon: "iconfont httpicon-shouye",
              index: "homepage",
              title: "Door Lock Homepage",
              key: 'HOME_PAGE',
              status: 0,
              id:4,
              pid:1,
              ChildrenStatus: false,
            },{
              icon: "iconfont httpicon-shouye",
              index: "watermeterhomepage",
              title: "Water Meter Home Page",
              key: 'WATER_METER',
              status: 0,
              id:5,
              pid:1,
              ChildrenStatus: false,
            },{
              icon: "iconfont httpicon-shouye",
              index: "electricitymeterhomepage",
              title: "Electric Meter Home Page",
              key: 'ELECTRIC_METER',
              status: 0,
              id:6,
              pid:1,
              ChildrenStatus: false,
            },
            {
              icon: "iconfont httpicon-shouye",
              index: "index",
              title: "Door Magnet Home Page",
              key: 'INDEX',
              status: 0,
              id:7,
              pid:1,
              ChildrenStatus: false,
            },{
              icon: "iconfont httpicon-shouye",
              index: "trashMonitorHomePage",
              title: "Trash Can Detector",
              key: 'TRASHMONITORHOMEPAGE',
              status: 0,
              id:8,
              pid:1,
              ChildrenStatus: false,
            },{
              icon: "iconfont httpicon-shouye",
              index: "airQualityMonitorHomePage",
              title: "Air Sensor",
              key: 'AIRQUALITYMONITORHOMEPAGE',
              status: 0,
              id:9,
              pid:1,
              ChildrenStatus: false,
            },
            // {
            //   icon: "iconfont httpicon-shouye",
            //   index: "smokeSensationDeviceHomePage",
            //   title: "Smoke Alarm Homepage",
            //   key: 'SMOKESENSATIONDEVICEHOMEPAGE',
            //   status: 0,
            //   id:10,
            //   pid:1,
            //   ChildrenStatus: false,
            // },
            // {
            //   icon: "iconfont httpicon-shouye",
            //   index: "homePageEnvironmentalQualityMonitor",
            //   title: "环境质量监测器首页",
            //   key: 'HOMEPAGEENVIRONMENTALQUALITYMONITOR',
            //   status: 0,
            //   ChildrenStatus: false,
            // },
            {
              icon: "iconfont httpicon-shouye",
              index: "manholeCoverMonitorHomePage",
              title: "Manhole Cover Monitor",
              key: 'MANHOLECOVERMONITORHOMEPAGE',
              status: 0,
              id:11,
              pid:1,
              ChildrenStatus: false,
            },{
              icon: "iconfont httpicon-shouye",
              index: "smartButtonHomePage",
              title: "Smart Button",
              key: 'SMARTBUTTONHOMEPAGE',
              status: 0,
              id:12,
              pid:1,
              ChildrenStatus: false,
            },{
              icon: "iconfont httpicon-shouye",
              index: "acoustoopticAlarmHomePage",
              title: "Sound and Light Alarm",
              key: 'ACOUSTOOPTICALARMHOMEPAGE',
              status: 0,
              id:13,
              pid:1,
              ChildrenStatus: false,
            },
            // {
            //   icon: "iconfont httpicon-shouye",
            //   index: "homePageDistributionCabinetIsEmpty",
            //   title: "Distribution Cabinet Circuit Breaker",
            //   key: 'HOME_PAGE_DISTRIBUTION_CABINET_IS_EMPTY',
            //   status: 0,
            //   id:14,
            //   pid:1,
            //   ChildrenStatus: false,
            // },
            {
              icon: "iconfont httpicon-shouye",
              index: "infraredAlarmHomePage",
              title: "Infrared Alarm",
              key: 'INFRAREDALARMHOMEPAGE',
              status: 0,
              id:15,
              pid:1,
              ChildrenStatus: false,
            },
            // {
            //   icon: "iconfont httpicon-shouye",
            //   index: "homePageWaterAndElectricityMeter",
            //   title: "Water and Electricity Meter",
            //   key: 'HOME_PAGE_WATER_AND_ELECTRICITY_METER',
            //   status: 0,
            //   id:14,
            //   pid:1,
            //   ChildrenStatus: false,
            // },
            {
              icon: "iconfont httpicon-shouye",
              index: "sharedHotWaterHomePage",
              title: "Shared Hot Water",
              key: 'SHARED_HOT_WATER_HOME_PAGE',
              status: 0,
              id:161,
              pid:1,
              ChildrenStatus: false,
            },
          ],
        },
        {
          icon: "iconfont httpicon-loufang01",
          index: "room",
          title: "Property Management",
          key: 'AREA_MANAGEMENT',
          status: 0,
          id:16,
          pid:16,
          ChildrenStatus: true,
          subs: [{
            index: "room",
            title: "Door Lock Property List",
            key: 'STUDENT_DORMITORY',
            status: 0,
            id:17,
            pid:16,
            ChildrenStatus: false,
          },
            {
              index: "Architecture",
              title: "Door Magnet Property List",
              key: 'ARCCHITECTURE',
              status: 0,
              id:18,
              pid:16,
              ChildrenStatus: false,
            },
            // {
            //   index: "offInHouse",
            //   title: "离线房源",
            //   key: 'OFF_IN_HOUSE',
            //   status: 0,
            //   ChildrenStatus: false,
            // },
          ],
        },
        {
          icon: "iconfont httpicon-yewuguanli",
          index: "CheckIn",
          title: "Business Management",
          key: 'OPERATIONS_MANAGEMENT',
          status: 0,
          id:19,
          pid:19,
          ChildrenStatus: true,
          subs: [{
            icon: "el-icon-lx-copy",
            index: "RoomInquiry",
            title: "Door Lock Business",
            key: 'ACCOMMODATION_OPERATION',
            status: 0,
            id:20,
            pid:19,
            ChildrenStatus: true,
            subs: [{
              index: "CheckIn",
              title: "Check-in Management",
              key: 'ACCOMMODATION_REGISTER',
              status: 0,
              id:21,
              pid:20,
              ChildrenStatus: false,
            },
              {
                index: "Refund",
                title: "Check-out Management",
                key: 'CHECK_OUT_MANAGEMENT',
                status: 0,
                id:22,
                pid:20,
                ChildrenStatus: false,
              },
              {
                index: "renewalHandling",
                title: "Extension Management",
                key: 'RENEWAL_HANDLING',
                status: 0,
                id:23,
                pid:20,
                ChildrenStatus: false,
              },
              {
                index: "Freeze",
                title: "Freeze Management",
                key: 'FREEZE_MANAGEMENT',
                status: 0,
                id:24,
                pid:20,
                ChildrenStatus: false,
              },
              {
                index: "linkperson",
                title: "Alarm Contact",
                key: 'LINKPERSON',
                status: 0,
                id:25,
                pid:20,
                ChildrenStatus: false,
              },
            ],
          },
            {
              icon: "el-icon-lx-copy",
              index: "Linkman",
              title: "Door Magnet Business",
              key: 'DOORMAGNETICSERVICE',
              status: 0,
              id:26,
              pid:19,
              ChildrenStatus: true,
              subs: [{
                index: "Linkman",
                title: "Alarm Contact",
                key: 'LINKMAN',
                status: 0,
                id:27,
                pid:26,
                ChildrenStatus: false,
              }, ],
            },{
              index: "offInCardManage",
              title: "Offline Card Management",
              key: 'OFF_IN_CARD_MANAGE',
              status: 0,
              id:28,
              pid:19,
              ChildrenStatus: true,
              subs:[
                {
                  index: "offInCardOver",
                  title: "Offline Card Operation",
                  key: 'OFF_IN_CARD_OVER',
                  status: 0,
                  id:29,
                  pid:28,
                  ChildrenStatus: false
                },
                {
                  index: "offInCardList",
                  title: "Offline Card List",
                  key: 'OFF_IN_CARD_LIST',
                  status: 0,
                  id:30,
                  pid:28,
                  ChildrenStatus: false
                }
              ]
            },
          ],
        },
        {
          icon: "iconfont httpicon-yiqiatong",
          index: "userManagement",
          title: "Personnel Management",
          key: 'PERSONNEL_MANAGEMENT',
          status: 0,
          id:31,
          pid:31,
          ChildrenStatus: true,
          subs: [{
            index: "userManagement",
            title: "Personnel List",
            key: 'STUDENT_INFORMATION',
            status: 0,
            id:32,
            pid:31,
            ChildrenStatus: false,
          },
            {
              index: "VoucherList",
              title: "Credential Management",
              key: 'RENT_SURRENDER_MANAGEMENT',
              status: 0,
              id:33,
              pid:31,
              ChildrenStatus: false,
            },
            {
              index: "bluetoothButtonManage",
              title: "Bluetooth Tag Management",
              key: 'BLUETOOTH_BUTTON_MANAGE',
              status: 0,
              id:34,
              pid:31,
              ChildrenStatus: false,
            },
            {
              index: "InformationBase",
              title: "Information Database",
              key: 'INFORMATIONBASE',
              status: 0,
              id:35,
              pid:31,
              ChildrenStatus: false,
            },
          ],
        },
        {
          icon: "iconfont httpicon-shebei",
          index: "doorLock",
          title: "Device Management",
          key: 'DEVICE_MANAGEMENT',
          status: 0,
          id:36,
          pid:36,
          ChildrenStatus: true,
          subs: [{
            icon: "el-icon-lx-copy",
            index: "doorLock",
            title: "Door Lock Devices",
            key: 'DOOR_LOCK_DEVICE',
            status: 0,
            id:37,
            pid:36,
            ChildrenStatus: false,
          },{
            icon: "el-icon-lx-copy",
            index: "waterMeterDevice",
            title: "Water Meter Device",
            key: 'WATER_METER_DEVICE',
            status: 0,
            id:370,
            pid:36,
            ChildrenStatus: false,
          },{
            icon: "el-icon-lx-copy",
            index: "electricMeterDevice",
            title: "Electric Meter Device",
            key: 'ELECTRIC_METER_DEVICE',
            status: 0,
            id:371,
            pid:36,
            ChildrenStatus: false,
          },
            {
              icon: "el-icon-lx-copy",
              index: "EquipmentList",
              title: "Door Magnet Devices",
              key: 'EQUIPMENTLIST',
              status: 0,
              id:38,
              pid:36,
              ChildrenStatus: false,
            },{
              icon: "el-icon-lx-copy",
              index: "airSwitchDevice",
              title: "Circuit Breaker Devices",
              key: 'AIRSWITCH',
              status: 0,
              id:39,
              pid:36,
              ChildrenStatus: false,
            },
            {
              icon: "el-icon-lx-copy",
              index: "smokeSensationDevice",
              title: "Smoke Sensor Devices",
              key: 'SMOGDETECTOR',
              status: 0,
              id:40,
              pid:36,
              ChildrenStatus: false,
            },
            // {
            //   icon: "el-icon-lx-copy",
            //   index: "AirCleaningDevice",
            //   title: "空气净化",
            //   key: 'AIRCLEANER',
            //   status: 0,
            //   ChildrenStatus: false,
            // },
            {
              icon: "el-icon-lx-copy",
              index: "smartButtonDevice",
              title: "Smart Button",
              key: 'ACTIVEBUTTON',
              status: 0,
              id:41,
              pid:36,
              ChildrenStatus: false,
            },{
              icon: "el-icon-lx-copy",
              index: "manholeCoverDevice",
              title: "Manhole Cover",
              key: 'MANHOLECOVER',
              status: 0,
              id:42,
              pid:36,
              ChildrenStatus: false,
            },{
              icon: "el-icon-lx-copy",
              index: "trashCanDevice",
              title: "Trash Bin",
              key: 'GARBAGE',
              status: 0,
              id:43,
              pid:36,
              ChildrenStatus: false,
            },{
              icon: "el-icon-lx-copy",
              index: "gatewayDevice",
              title: "Gateway",
              key: 'GATEWAY',
              status: 0,
              id:44,
              pid:36,
              ChildrenStatus: false,
            },{
              icon: "el-icon-lx-copy",
              index: "airDetectionDevice",
              title: "Air Quality Sensor",
              key: 'AIRDETECTION',
              status: 0,
              id:45,
              pid:36,
              ChildrenStatus: false,
            }, {
              icon: "el-icon-lx-copy",
              index: "humanMotionSensorDevice",
              title: "Infrared Sensor",
              key: 'HUMANMOVING',
              status: 0,
              id:46,
              pid:36,
              ChildrenStatus: false,
            },{
              icon: "el-icon-lx-copy",
              index: "acoustoopticAlarm",
              title: "Alarm device",
              key: 'ACOUSTOOPTIC_ALARM',
              status: 0,
              id:47,
              pid:36,
              ChildrenStatus: false,
            },{
              icon: "el-icon-lx-copy",
              index: "quantityConfiguration",
              title: "Device Quantity",
              key: 'quantityConfiguration',
              status: 0,
              id:48,
              pid:36,
              ChildrenStatus: false,
            },
          ],
        },
        {
          icon: "iconfont httpicon-yiqiatong",
          index: "accessControl",
          title: "门禁管理",
          key: 'ACCESS_CONTROL',
          status: 0,
          id: 77,
          pid: 77,
          ChildrenStatus: false,
        },
        {
          icon: 'iconfont httpicon-shebei',
          index: "garageGate",
          title: "Garage gate",
          key: 'GARAGE_GATE',
          status: 0,
          id: 78,
          pid: 78,
          ChildrenStatus: false
        },
        {
          icon: "iconfont httpicon-yonghuguanli",
          index: "loginAccount",
          title: "User Management",
          key: 'USER_MANAGEMENT',
          status: 0,
          id:49,
          pid:49,
          ChildrenStatus: true,
          subs: [{
            index: "loginAccount",
            title: "Login Account",
            key: 'ACCOUNT_MANAGEMENT',
            status: 0,
            id:50,
            pid:49,
            ChildrenStatus: false,
          },
            // {
            //   index: "userManagementHouse",
            //   title: "门磁登录账号",
            //   key: 'DOORMAGENTLOGINACCOUNT',
            //   status: 0,
            // },
            {
              index: "rolePermissions",
              title: "Role Permissions",
              key: 'ROLE_PERMISSIONS',
              status: 0,
              id:51,
              pid:49,
              ChildrenStatus: false,
            },
            {
              index: "bindingRoles",
              title: "Bind Roles",
              key: 'BOUND_ROLE',
              status: 0,
              id:52,
              pid:49,
              ChildrenStatus: false,
            },
            // {
            //   index: "configPage",
            //   title: "配置",
            //   key: 'CONFIGPAGE',
            //   status: 0,
            //   id:53,
            //   pid:49,
            //   ChildrenStatus: false,
            // },
          ],
        },
        {
          icon: "iconfont httpicon-pingzhengguanli",
          index: "rechargeManagement",
          title: "Financial Management",
          key: 'RECHARGE_MANAGEMENT',
          status: 0,
          pid:90,
          id:90,
          ChildrenStatus: true,
          subs: [
            {
              icon: "iconfont httpicon-pingzhengguanli",
              index: "bill",
              title: "Bills",
              key: 'BILL',
              status: 0,
              pid:90,
              id:91,
              ChildrenStatus: false
            },
            {
              icon: "iconfont httpicon-pingzhengguanli",
              index: "rechargeManagement",
              title: "Recharge",
              key: 'RECHARGE_MANAGEMENT',
              status: 0,
              pid:90,
              id:92,
              ChildrenStatus: false
            }
          ]
        },
        // {
        //   icon: "iconfont httpicon-pingzhengguanli",
        //   index: "rechargeManagement",
        //   title: "Recharge Management",
        //   key: 'RECHARGE_MANAGEMENT',
        //   status: 0,
        //   id:54,
        //   pid:54,
        //   ChildrenStatus: false,
        // },
        {
          icon: "iconfont httpicon-rizhiguanli",
          index: "journal",
          title: "Log Management",
          key: 'LOG_MANAGEMENT',
          status: 0,
          id:55,
          pid:55,
          ChildrenStatus: true,
          subs: [{
            index: "journal",
            title: "System Logs",
            key: 'journal',
            status: 0,
            id:56,
            pid:55,
            ChildrenStatus: false,
          },
            {
              index: "doorLockLlog",
              title: "Door Lock Logs",
              key: 'DOORLOCKLOG',
              status: 0,
              id:57,
              pid:55,
              ChildrenStatus: true,
              subs: [{
                index: "warningLog",
                title: "Alarm Logs",
                key: 'warningLog',
                status: 0,
                id:58,
                pid:57,
                ChildrenStatus: false,
              },
                {
                  index: "UnlockRecord",
                  title: "Unlock Records",
                  key: 'UnlockRecord',
                  status: 0,
                  id:59,
                  pid:57,
                  ChildrenStatus: false,
                },
                {
                  index: "bluetoothUnlockRecord",
                  title: "Bluetooth Unlock",
                  key: 'bluetoothUnlockRecord',
                  status: 0,
                  id:60,
                  pid:57,
                  ChildrenStatus: false,
                },
                {
                  index: "NoNc",
                  title: "Always Open/Close",
                  key: 'NONC',
                  status: 0,
                  id:61,
                  pid:57,
                  ChildrenStatus: false,
                },
                {
                  index: "DeviceFeedbackLog",
                  title: "Operation Records",
                  key: 'DeviceFeedbackLog',
                  status: 0,
                  id:62,
                  pid:57,
                  ChildrenStatus: false,
                },
              ]
            },
            {
              index: "alarmRecord",
              title: "Door Magnet Logs",
              key: 'DOORMAGNETICLOG',
              status: 0,
              id:63,
              pid:55,
              ChildrenStatus: true,
              subs: [{
                index: "alarmRecord",
                title: "Alarm Logs",
                key: 'ALARMRECORD',
                status: 0,
                id:64,
                pid:63,
                ChildrenStatus: false,
              }]
            },
            // {
            //   index: "emptyLog",
            //   title: "Circuit Breaker Logs",
            //   key: 'EMPTYLOG',
            //   status: 0,
            //   id:65,
            //   pid:55,
            //   ChildrenStatus: false
            // },
            // {
            //   index: "smokeLog",
            //   title: "Smoke Sensor Logs",
            //   key: 'SMOKELOG',
            //   status: 0,
            //   id:66,
            //   pid:55,
            //   ChildrenStatus: false
            // },
            // {
            //   index: "airCleaningLog",
            //   title: "空气清洁日志",
            //   key: 'AIRCLEANINGLOG',
            //   status: 0,
            //   ChildrenStatus: false
            // },
            {
              index: "smartButtonLog",
              title: "Smart Button Logs",
              key: 'SMART_BUTTON_LOG',
              status: 0,
              id:67,
              pid:55,
              ChildrenStatus: false
            },
            {
              index: "manholeCoverLog",
              title: "Manhole Cover Logs",
              key: 'MANHOLE_COVER_LOG',
              status: 0,
              id:68,
              pid:55,
              ChildrenStatus: false
            },
            {
              index: "trashLog",
              title: "Trash Bin Logs",
              key: 'TRASH_LOG',
              status: 0,
              id:69,
              pid:55,
              ChildrenStatus: false
            },
            {
              index: "gatewayLog",
              title: "Gateway Logs",
              key: 'GATEWAY_LOG',
              status: 0,
              id:70,
              pid:55,
              ChildrenStatus: false
            },
            {
              index: "airDetectionSensorLog",
              title: "Air Sensor Logs",
              key: 'AIR_DETECTION_SENSOR_LOG',
              status: 0,
              id:71,
              pid:55,
              ChildrenStatus: false
            },
            {
              index: "humanMotionSensorLog",
              title: "Infrared Sensor Logs",
              key: 'HUMAN_MOTION_SENSOR_LOG',
              status: 0,
              id:72,
              pid:55,
              ChildrenStatus: false
            },
            {
              index: "acoustoopticAlarmLog",
              title: "Alarm device Logs",
              key: 'ACOUSTOOPTIC_ALARM_LOG',
              status: 0,
              id:73,
              pid:55,
              ChildrenStatus: false
            },
          ],
        },
        {
          icon: "iconfont httpicon-xitongguanli",
          index: "systemConfiguration",
          title: "System Configuration",
          pid:101,
          id:110,
          key: 'SYSTEM_CONFIGURATION',
          status: 0,
          ChildrenStatus: false
        },
        {
          icon: "iconfont httpicon-xitongguanli",
          index: "thirdPartyDocking",
          title: "Third-party docking",
          pid: 605,
          id: 655,
          key: 'thirdPartyDocking',
          status: 0,
          ChildrenStatus: false
        },
        {
          icon: "iconfont httpicon-yewuguanli",
          index: "Lease",
          title: "Lease Management",
          key: 'LEASE MANAGEMENT',
          status: 0,
          ChildrenStatus: true,
          pid: 106,
          id: 106,
          subs: [{
            icon: "iconfont httpicon-rizhiguanli",
            index: "agreement",
            title: "Contract management",
            key: 'AGREEMENT',
            status: 0,
            pid: 106,
            id: 108,
            ChildrenStatus: false
          },
            {
              icon: "iconfont httpicon-rizhiguanli",
              index: "contractExportTemplate",
              title: "Contract export template",
              key: 'CONTRACT_EXPORT_TEMPLATE',
              status: 0,
              pid: 106,
              id: 109,
              ChildrenStatus: false,
            }]
        },
      ],
    },
  }
}



// WEBPACK FOOTER //
// ./src/utils/i18n.js